export type HealthIndicatorStatus = 'up' | 'down';

export type ApiHealthResponse = {
  status: 'ok' | 'error';
  info?: {
    database?: { status: HealthIndicatorStatus };
  };
  error?: {
    database?: { status: HealthIndicatorStatus | string };
  };
  details?: {
    database?: { status: HealthIndicatorStatus };
  };
};

export const API_HEALTH_QUERY_KEY = ['api-health'] as const;

export const API_HEALTH_FAILURE_THRESHOLD = 2;
export const API_HEALTH_TIMEOUT_MS = 10_000;
export const API_HEALTH_POLL_INTERVAL_HEALTHY_MS = 30_000;
export const API_HEALTH_POLL_INTERVAL_CHECKING_MS = 5_000;
export const API_HEALTH_POLL_INTERVAL_UNHEALTHY_MS = 15_000;
